import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { Table } from 'shared/ui'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { useAutomationLogsContext } from 'pages/settings/pages/integrations/context/automationLogsContext'
import { getColumns } from './getColumns'

import styles from './styles.module.scss'

export const AutomationLogsTable = observer(() => {
  const {
    listStore: {
      tableStore,
      items,
      startPaginationSize,
      limit,
      page,
      onPaginationModelChange,
      total,
      loading,
      onDetails,
    },
  } = useAutomationLogsContext()

  const columns = useMemo(getColumns, [])

  if (!items.length && !loading) {
    return <NoResultsFound />
  }

  return (
    <div className={styles.wrap}>
      <Table
        ariaLabel={'AutomationLogsTable'}
        pinnedColumnNames={['source']}
        store={tableStore}
        columns={columns}
        rows={items}
        rowsCount={total}
        isLoading={loading}
        onChangePagination={onPaginationModelChange}
        initPage={page}
        onRowClick={onDetails}
        limit={limit}
        startPaginationSize={startPaginationSize}
        virtualization
      />
    </div>
  )
})
